/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetExamPeriods = require('../services/GetExamPeriods');

var NonDepInternalExamsView = require('../views/NonDepInternalExamsView');

module.exports = function() {
  NProgress.start();
  NProgress.set(0.6);

  GetExamPeriods().done(function(examPeriods) {
    NavUtils.navigate('nondep/dashboard/exams');
    Scaffold.content.show(
      new NonDepInternalExamsView({
        model: new Backbone.Model({ examPeriods: examPeriods })
      })
    );
    NProgress.done();
  });
};
